import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { deleteEvacuationsFailed, deleteEvacuationsSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { NO_CONTENT } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* deleteEvacuations(action) {
  try {
    const url = `${BACKEND_URL}/evacuations/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'DELETE', true);
    if (dataResponse.status === NO_CONTENT) {
      yield put(deleteEvacuationsSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(deleteEvacuationsFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(deleteEvacuationsFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
